import { useContext } from 'react';
import clsx from 'clsx';

import InventoryAssetTree from '@atom/components/common/inventoryAssetTree/InventoryAssetTree';
import { InventoryCategoryTree } from '@atom/types/inventory';
// TODO(AM-18745): remove toggle
import { showDevelopmentFeature } from '@atom/utilities/featureToggleUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import CreateAssetModalContext from './CreateAssetModalContext';

import classes from './createAssetModal.module.css';

const FolderSelectionTab = () => {
  const { schema, category, setCategory, openCategories, setOpenCategories } =
    useContext(CreateAssetModalContext);
  const handleCategorySelect = (selectedCategory: InventoryCategoryTree) => {
    // Only select if category is leaf node
    if (isNilOrEmpty(selectedCategory?.categories)) {
      setCategory(selectedCategory);
    }
  };

  return (
    <div className={classes.tabContainer}>
      <div className={classes.tabTitle}>Inventory Folder</div>
      <div className={classes.titleSubtext}>
        Select a folder to organize this inventory in Atom.
      </div>
      <div className={clsx(classes.listContainer, classes.folder)}>
        <InventoryAssetTree
          includeAssets={false}
          search="categories"
          onCategoryClick={data => handleCategorySelect(data)}
          onCategoryExpand={open => setOpenCategories(open)}
          openCategories={openCategories}
          disabledCategoryIds={new Set(['inventory'])}
          schemaId={schema?.id}
          selectedCategoryId={category?.id}
          {...(!showDevelopmentFeature && {
            includeMaterials: schema?.isMaterial,
            includeLocationBased: !schema?.isMaterial,
          })}
          onlyPublishedCategories
          dataCyPrefix="globalCreateAssetModalTree"
          isAssetCreate
        />
      </div>
    </div>
  );
};

export default FolderSelectionTab;
